<template>
  <div class="errPage-container">
    <button icon="arrow-left" class="pan-back-btn" @click="back">
      返回
    </button>
    <div style="text-align: center">
        <h1 class="text-jumbo text-ginormous">
          Oops!
        </h1>
        <h2 style="margin-bottom: 5px">你没有权限去该页面</h2>
        <h6>如有不满请联系你领导</h6>
        <ul class="list-unstyled">
          <li>或者你可以去:</li>
          <li class="link-type">
            <router-link to="/newindex">
              回首页
            </router-link>
          </li>
        </ul>

        <img :src="errGif" width="313" height="428" alt="Girl has dropped her ice cream.">
    </div>
  </div>
</template>

<script>
import errGif from '@/assets/401_images/401.gif'

export default {
  name: 'Page401',
  data() {
    return {
      errGif: errGif + '?' + +new Date()
    }
  },
  methods: {
    back() {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: '/dashboard' })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .errPage-container {
    width: 800px;
    max-width: 100%;
    margin: 10px auto;
    .pan-back-btn {
      background: #008489;
      color: #fff;
      border: none!important;
    }
    .pan-gif {
      margin: 0 auto;
      display: block;
    }
    .pan-img {
      display: block;
      margin: 0 auto;
      width: 100%;
    }
    .text-jumbo {
      font-size: 60px;
      font-weight: 700;
      color: #484848;
      margin: 10px 0;
    }
    .list-unstyled {
      font-size: 14px;
      li {
        padding: 5px 0;
      }
      a {
        color: #008489;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>
